import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@shared/components/ui/form';
import { cn } from '@shared/lib/utils';
import { ClassValue } from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Textarea, TextareaProps } from '../ui/textarea';

type TextareaFormFieldProps = TextareaProps & {
  name: string;
  className?: ClassValue;
  inputClassName?: ClassValue;
  includeErrorMessage?: boolean;
  label?: string;
  optional?: boolean;
};
export default function InputFormField({
  name,
  className,
  label,
  includeErrorMessage = false,
  inputClassName,
  optional = false,
  ...props
}: TextareaFormFieldProps) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={cn('grid w-full items-center', className)}>
          {label && (
            <FormLabel htmlFor={name}>
              {label}{' '}
              {optional && (
                <span className="text-xs font-normal text-muted-foreground">
                  (optional)
                </span>
              )}
            </FormLabel>
          )}
          <div className="relative">
            <FormControl>
              <Textarea
                className={cn(
                  'w-full placeholder:text-gray-400',
                  {
                    'border-destructive': fieldState.error,
                  },
                  inputClassName
                )}
                {...field}
                {...props}
              />
            </FormControl>
          </div>
          {includeErrorMessage && <FormMessage />}
        </FormItem>
      )}
    />
  );
}
